module.exports = __webpack_public_path__ + "img/5.fbb91fe0.gif";